import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOnTap]',
  standalone: true,
})
export class OnTapDirective {
  nativeElement: HTMLElement | null = null;
  touchStarted = false;

  /**
   * Events which will trigger `triggerEvent`
   */
  @Input() tapEvents: ('click' | 'touch')[] = ['touch', 'click'];
  /**
   * The event to trigger when the tap events occur
   */
  @Input() triggerEvent: 'focus' | 'click' = 'focus';

  isTouchOnThisElement(type: 'start' | 'end', $event: TouchEvent): boolean {
    if (!this.nativeElement) {
      return false;
    }
    const touch =
      type === 'start' ? $event.touches[0] : $event.changedTouches[0];
    const boundingRect = this.nativeElement.getBoundingClientRect();
    return this.areCoordsWithinBoundingRect(
      touch?.clientX ?? 0,
      touch?.clientY ?? 0,
      boundingRect,
    );
  }

  areCoordsWithinBoundingRect(x: number, y: number, rect: DOMRect): boolean {
    return (
      x >= rect.x &&
      x <= rect.x + rect.width &&
      y >= rect.y &&
      y <= rect.y + rect.height
    );
  }

  @HostListener('touchstart', ['$event']) onTouchStart(
    $event: TouchEvent,
  ): void {
    if (!this.tapEvents.includes('touch')) {
      return;
    }
    $event.stopPropagation();
    if (!this.nativeElement) {
      return;
    }
    const isTouchOnThisElement = this.isTouchOnThisElement('start', $event);
    if (isTouchOnThisElement) {
      this.touchStarted = true;
    }
  }

  @HostListener('touchend', ['$event']) onTouchEnd($event: TouchEvent): void {
    if (!this.tapEvents.includes('touch')) {
      return;
    }
    $event.stopPropagation();
    if (!this.nativeElement) {
      return;
    }
    const isTouchOnThisElement = this.isTouchOnThisElement('end', $event);
    if (this.touchStarted && isTouchOnThisElement) {
      this.nativeElement[this.triggerEvent]();
    }
    this.touchStarted = false;
  }

  @HostListener('click', ['$event']) onClick($event: MouseEvent): void {
    if (!this.tapEvents.includes('click')) {
      return;
    }
    $event.stopPropagation();
    if (!this.nativeElement) {
      return;
    }
    this.nativeElement[this.triggerEvent]();
  }

  constructor(private el: ElementRef) {
    this.nativeElement = this.el.nativeElement as HTMLElement;
  }
}
